import React, { CSSProperties } from "react";
import {
  SxProps,
  Theme,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Grid,
} from "@mui/material";
import successIconImg from "../assets/success-icon.webp";

import CloseIcon from "@mui/icons-material/Close";

interface Props {
  text: string;
  open: boolean;
  handleClose: () => void;
}

const ErrorPopupStyle: Record<string, SxProps<Theme>> = {
  dialogContainer: (theme: Theme) => ({
    background: "#282334",
    border: "3px solid",
    borderColor: theme.palette.secondary.main,
    borderRadius: "10px",
  }),
  dialogTitle: {
    fontSize: "1.5rem",
  },
  dialogDate: {
    color: "#BABABA",
  },
  dialogContent: {
    marginTop: "20px",
  },
  dialogContentText: {
    fontSize: "1.2rem",
    color: "white",
  },
  dialogButton: {
    fontSize: "1rem",
    color: "white",
  },
};

const ErrorPopup: React.FC<Props> = ({ text, open, handleClose }) => {
  return (
    <Dialog
      PaperProps={{ sx: ErrorPopupStyle.dialogContainer }}
      open={open}
      keepMounted
      onClose={handleClose}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.secondary.main,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Grid container>
          <Grid
            item
            md={3}
            sx={{
              img: {
                width: "100%",
                height: "auto",
              },
            }}
          ></Grid>
          <Grid item md={9}>
            <DialogTitle>{text}</DialogTitle>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorPopup;
